
import Banner from "../components/banner/banner"
import SideMenu from "../components/sideMenu/sideMenu"
import AnimatedPage from "../components/animatedPage"
import { useSelector, useDispatch } from "react-redux"
import { useEffect } from 'react';
import { retrunAssets } from './../utils/getAssets';
import { fetchFaqData } from "../redux/slice/faqPage"
import { Link } from "react-router-dom"
import { FaArrowRight } from "react-icons/fa6"
import FaqContent from "../components/faqContent"
import { DecodeHtml } from "../utils/decodeHtml"

const Faq = () => {


    const state = useSelector(state => state.faq)
    const dispatch = useDispatch()

    useEffect(() => {
        if (state?.data === null) {
            dispatch(fetchFaqData("faq?expand=properties%5B%24all%5D&fields=properties%5B%24all%5D"))
        }
    }, [state, dispatch])


    const faq = state?.data?.properties
    const text = faq?.title
    const bg = faq?.backgroundImage != null ? retrunAssets(faq?.backgroundImage[0]?.url) : ""
    const content = faq?.content
    const list = content != null ? [
        {
            title: "Frequently Ask Questions",
            subItems:
                content?.map((item, index) => {
                    return {
                        index: index,
                        name: item?.name
                    }
                }
                )

        },

    ]
        : []
        const contents = content && Array.isArray(content) ? content.map((item, index) => {
            if (!item || !item.properties) return null;
        
            const accordionData = item.properties.accordions?.items?.map((accordionDataItem, subIndex) => {
                if (!accordionDataItem || !accordionDataItem.content || !accordionDataItem.content.properties) return null;
        
                const properties = accordionDataItem.content.properties;
                return {
                    open: subIndex === 0,
                    question: properties.label,
                    answer: DecodeHtml({ html: properties.accordionContent?.markup })
                };
            }).filter(Boolean);
        
            return (
                <FaqContent
                    key={index}
                    title={item.properties.title}
                    accordionData={accordionData}
                />
            );
        }).filter(Boolean) : []
    
    
    return (
        <AnimatedPage>
            <Banner text={text} bg={bg} />
            <div className="flex justify-center bg-white p-4 md:py-8 w-full">
                <div className="w-full flex flex-col gap-5 lg:px-16  ">
                    <SideMenu list={list} contents={contents} >
                        <div className="p-4 flex items-center w-full my-8">
                            <div className="flex w-full flex-col gap-3  py-10 items-center rounded-lg bg-[#02265B]">
                                <h2 className="w-auto max-w-[20ch] text-center font-bold text-white text-xl leading-tight">{`Have more Questions ?`}</h2>
                                <Link to={'/contact-us'} className="px-8 py-4 w-fit  bg-red-800 rounded justify-center items-center gap-4 flex">
                                    <span className="text-white  text-base font-bold capitalize flex items-center gap-3">Contact Us <FaArrowRight /></span>
                                </Link>

                            </div>
                        </div>
                    </SideMenu>


                </div>
            </div>
        </AnimatedPage>
    )
}

export default Faq